import React from 'react';
import HandoverDetailContent, { HandoverLeg } from './HandoverDetailContent';
import {
  displayValue,
  formatDateTime,
  formatOdometer,
  formatSchedule,
  buildEquipmentChecklist,
  HandoverDetailRecord,
  resolveCondition,
  resolveHandoverPlate,
  resolveReturnReason,
} from './handoverDetailDisplay';

interface HandoverDetailViewProps {
  handover: HandoverDetailRecord;
  /**
   * Which leg the reader asked about. Omit for the whole row — the standalone
   * handover screens are not opened "as" a leg.
   */
  leg?: HandoverLeg;
}

/**
 * The canonical handover detail, derived straight from the record.
 *
 * `HandoverDetailContent` stays presentational — every label and formatter is
 * still a prop — so this wrapper is what callers should reach for: it owns the
 * derivation once, which is what keeps the handover screen and the rent screen
 * from drifting apart.
 */
const HandoverDetailView: React.FC<HandoverDetailViewProps> = ({
  handover,
  leg,
}) => {
  const returnReason = resolveReturnReason(handover);

  return (
    <HandoverDetailContent
      handover={handover}
      leg={leg}
      titlePlate={resolveHandoverPlate(handover)}
      returnReasonValue={returnReason.value}
      returnReasonDetail={returnReason.detail}
      conditionValue={resolveCondition(handover)}
      equipmentChecklist={buildEquipmentChecklist(handover)}
      formatOdometer={formatOdometer}
      formatDateTime={formatDateTime}
      formatSchedule={formatSchedule}
      displayValue={displayValue}
    />
  );
};

export default HandoverDetailView;
